import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FocusService {
  readonly focusedTileId = signal<string | null>(null);

  open(id: string): void {
    this.focusedTileId.set(id);
  }

  close(): void {
    this.focusedTileId.set(null);
  }

  toggle(id: string): void {
    this.focusedTileId.update(current => (current === id ? null : id));
  }
}
